import React, { PropTypes, Component } from 'react'
import classes from './Searchbox.scss'

class Searchbox extends Component {
  static propTypes = {
    description: PropTypes.string,
    keyword: PropTypes.string,
    onSearch: PropTypes.func.isRequired
  }

  constructor (props) {
    super(props)
    this.state = { keyword: props.keyword || '' }
  }

  componentDidMount () {
    window.objectFitImages()
  }

  _onChange = (e) => {
    this.setState({ keyword: e.currentTarget.value })
  }

  _onKeyDown = ({ keyCode }) => {
    if (keyCode === 13) {
      this.props.onSearch(this.state.keyword)
    }
  }

  render () {
    const { description, onSearch } = this.props
    return (
      <div className={classes.searchbox}>
        <div className={classes.inputSearchContainer}>
          <input className={classes.inputSearch} type='text'
            value={this.state.keyword} onChange={this._onChange} onKeyDown={this._onKeyDown} />
          <div className={classes.btnSearch} onClick={() => onSearch(this.state.keyword)}>
            <img src='/images/icon-search-white.png' alt='icon-search-white' />
          </div>
        </div>
        <span className={classes.descriptionSearch}>{description}</span>
      </div>
    )
  }
}

export default Searchbox



/** WEBPACK FOOTER **
 ** ./src/components/Searchbox.js
 **/